import React from "react";
import { Globe, Star, TrendingUp, ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

const features = [
    {
        icon: Globe,
        title: "Always-on visibility",
        desc: "Your business appears to every SignetPrint user in your area, 24/7. No ad spend required.",
    },
    {
        icon: Star,
        title: "Social proof built in",
        desc: "Google reviews display automatically on your listing, building instant trust with new customers.",
    },
    {
        icon: TrendingUp,
        title: "Grow without marketing",
        desc: "Customers discover you organically. More orders and enquiries, zero marketing overhead.",
    },
];

const MarketplaceSection = () => {
    const navigate = useNavigate();

    return (
        <section className="bg-white border-y border-[#e4e5e7]">
            <div className="max-w-[1200px] mx-auto px-[16px] md:px-[40px] py-[56px] md:py-[80px]">

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-[32px] lg:gap-[48px] items-center">

                    {/* IMAGE SIDE */}
                    <div className="relative order-2 lg:order-1">
                        <div className="rounded-[20px] overflow-hidden border border-[#e4e5e7] shadow-[0px_8px_32px_rgba(0,0,0,0.08)]">
                            <img
                                src="https://images.unsplash.com/photo-1758183961426-88d64eb5f787?auto=format&fit=crop&w=1080&q=80"
                                alt="Commercial printing"
                                className="w-full h-[400px] md:h-[520px] object-cover"
                            />
                        </div>
                    </div>

                    {/* CONTENT SIDE */}
                    <div className="order-1 lg:order-2">
                        <p className="font-semibold text-[13px] text-[#ff5323] tracking-[0.5px] uppercase mb-[8px]">
                            Marketplace
                        </p>

                        <h2 className="font-semibold text-[28px] md:text-[36px] text-[#212326] tracking-[-0.5px] mb-[12px]">
                            Shops and suppliers, all in one marketplace.
                        </h2>

                        <p className="font-medium text-[16px] text-[#717182] leading-[1.7] mb-[28px]">
                            SignetPrint isn't just a file transfer tool - it's a discovery platform for the entire print industry.
                            Print shops receive jobs and files, while suppliers get found by the businesses that need their products.
                        </p>

                        {/* FEATURES */}
                        <div className="flex flex-col gap-[16px] mb-[28px]">
                            {features.map((item, idx) => {
                                const Icon = item.icon;
                                return (
                                    <div key={idx} className="flex items-start gap-[14px]">
                                        <div className="w-[36px] h-[36px] rounded-[10px] bg-[#fff0ec] flex items-center justify-center shrink-0 mt-[1px]">
                                            <Icon className="w-[18px] h-[18px] text-[#ff5323]" />
                                        </div>

                                        <div>
                                            <p className="font-semibold text-[14px] text-[#212326] mb-[2px]">
                                                {item.title}
                                            </p>
                                            <p className="font-medium text-[13px] text-[#717182] leading-[1.5]">
                                                {item.desc}
                                            </p>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>

                        {/* CTA */}
                        <button
                            onClick={() => navigate("/onboarding/plan")}
                            className="inline-flex items-center gap-[8px] px-[24px] py-[12px] rounded-[10px] bg-[#ff5323] text-white font-semibold text-[14px] hover:bg-[#e64a1f] transition-colors no-underline shadow-[0px_2px_8px_rgba(255,83,35,0.3)]"
                        >
                            List Your Business
                            <ArrowRight className="w-[14px] h-[14px]" />
                        </button>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default MarketplaceSection;
